<template>
  <div>
    <h3>Saved Research:</h3>
    <ul>
      <li v-for="(item, index) in savedResearches" :key="index">
        {{ item.date }}
        <ul>
          <li>Abductee: {{ item.abductee }}</li>
          <li>D.O.B: {{ item.abducteedob }}</li>
          <li>Abductor: {{ item.abductor }}</li>
          <li>Family Country: {{ item.familyCountry }}</li>
          <li>Missing Since: {{ item.missingSince }}</li>
          <li>Abductee Social Media: {{ item.abducteeSocialMedia }}</li>
          <li>Abductor Social Media: {{ item.abductorSocialMedia }}</li>
          <li>Last Known Address: {{ item.lastKnownAddress }}</li>
          <li>Case Type: {{ item.caseType }}</li>
          <li>Last Saved Query: {{ item.lastSavedQuery }}</li>
          <li>Last Saved URL: {{ item.lastSavedUrl }}</li>
          <li v-if="item.abducteeImage">
            Abductee Image: <a href="#" @click.prevent="openImageInNewTab(item.abducteeImage)">Open Image</a>
          </li>
        </ul>
        <button class="mx-2" @click="$emit('edit-research', index)">Edit</button>
        <button class="mx-2" @click="$emit('delete-research', index)">Delete</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedResearches: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openImageInNewTab(imageUrl) {
      window.open(imageUrl, '_blank');
    },
  },
};
</script>



<style>
/* Add any custom styles for the saved code list component */
</style>
